// ==========================================
// SAPUNA WHITE MUSK BODY OIL
// Full Shopify integration with auto-sync, add to cart, upsells, and quantity selector
// ==========================================

(function() {
  'use strict';
  
  // ==========================================
  // PRODUCT CONFIGURATION
  // ==========================================
  const mainProductHandle = 'white-musk-body-oil';
  const mainVariantId = 45925810438280;
  const whatsappNumber = '96170065685';
  const productTitle = 'White Musk Body Oil';
  const productImage = 'https://cdn.shopify.com/s/files/1/0683/6843/3288/files/body_oil_sapuna_white_musk.jpg';
  const fallbackPrice = 25.00;
  
  // Upsell products configuration (Body Oils only - NO SERUMS)
  const upsellConfigs = [
    {
      variantId: 45925810208904,
      handle: 'lavender-vanilla-body-oil',
      priceElementId: 'upsell-price-1',
      title: 'Lavender & Vanilla Body Oil',
      image: 'https://cdn.shopify.com/s/files/1/0683/6843/3288/files/body_oil_sapuna_lavender_vanilla.jpg?v=1780395035',
      fallbackPrice: 25.00
    },
    {
      variantId: 45925825216648,
      handle: 'coconut-milk-avocado-body-oil',
      priceElementId: 'upsell-price-2',
      title: 'Coconut Milk & Avocado Body Oil',
      image: 'https://cdn.shopify.com/s/files/1/0683/6843/3288/files/body_oil_sapuna_coconut_milk_avocado.jpg?v=1780395034',
      fallbackPrice: 25.00
    }
  ];
  
  // State variables
  let quantity = 1;
  let currentVariantId = mainVariantId;
  let currentPrice = fallbackPrice;
  let isInStock = true;
  let isSyncing = false;
  let upsellData = {};
  
  // DOM elements
  const quantitySpan = document.getElementById('sapuna-quantity');
  const minusBtn = document.getElementById('sapuna-qty-minus');
  const plusBtn = document.getElementById('sapuna-qty-plus');
  const addToCartBtn = document.getElementById('sapuna-add-to-cart');
  const successMsg = document.getElementById('sapuna-cart-success');
  const mainPriceEl = document.getElementById('sapuna-main-price');
  const whatsappBtn = document.querySelector('.sapuna-whatsapp-btn');
  
  // ==========================================
  // HELPER FUNCTIONS
  // ==========================================
  function formatMoney(amount) {
    if (typeof amount !== 'number' || isNaN(amount)) return '$0.00';
    return `$${amount.toFixed(2)}`;
  }
  
  function showMessage(message, isError = false) {
    if (!successMsg) return;
    successMsg.textContent = message;
    successMsg.style.color = isError ? '#dc3545' : '#57ADAE';
    successMsg.classList.add('show');
    setTimeout(() => {
      successMsg.classList.remove('show');
    }, 2000);
  }
  
  function updateWhatsAppLink() {
    if (!whatsappBtn) return;
    const stockText = isInStock ? 'In stock' : 'Sold out';
    const msg = encodeURIComponent(`Hello, I'm interested in ${productTitle} for ${formatMoney(currentPrice)}. ${stockText}`);
    whatsappBtn.href = `https://wa.me/${whatsappNumber}?text=${msg}`;
  }
  
  function updateAddToCartButton() {
    if (!addToCartBtn) return;
    if (!isInStock) {
      addToCartBtn.disabled = true;
      addToCartBtn.textContent = 'Sold Out';
    } else {
      addToCartBtn.disabled = false;
      addToCartBtn.textContent = 'Add to Cart →';
    }
  }
  
  // ==========================================
  // SHOPIFY ADD TO CART FUNCTION
  // ==========================================
  async function addToCart(variantId, title, image, handle, qty = null) {
    const quantityToAdd = qty !== null ? qty : quantity;
    
    try {
      if (typeof window.addToCart === 'function') {
        await window.addToCart({ 
          variantId: variantId, 
          quantity: quantityToAdd, 
          title: title, 
          image: image, 
          handle: handle 
        });
      } else {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: Number(variantId),
            quantity: quantityToAdd
          })
        });
        
        if (!response.ok) {
          const errorData = await response.json().catch(() => null);
          throw new Error(errorData && errorData.description ? errorData.description : 'Failed to add to cart');
        }
        
        if (typeof window.openCartDrawer === 'function') {
          window.openCartDrawer();
        }
        
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:updated'));
      }
      
      return true;
    } catch (error) {
      console.error('Add to cart error:', error);
      throw error;
    }
  }
  
  async function handleMainAddToCart() {
    if (!isInStock) {
      showMessage('This product is out of stock!', true);
      return;
    }
    
    if (!addToCartBtn) return;
    
    const originalText = addToCartBtn.textContent;
    addToCartBtn.disabled = true;
    addToCartBtn.textContent = 'Adding...';
    
    try {
      await addToCart(
        currentVariantId,
        productTitle,
        productImage,
        mainProductHandle,
        quantity
      );
      
      showMessage(`✓ Added ${quantity} item(s) to cart!`);
    } catch (error) {
      showMessage(error.message || 'Error adding to cart', true);
    }
    
    addToCartBtn.disabled = false;
    addToCartBtn.textContent = originalText;
    updateAddToCartButton();
  }
  
  async function handleUpsellAddToCart(event, btn, variantId) {
    event.stopPropagation();
    event.preventDefault();
    
    const upsellProduct = upsellData[variantId];
    if (!upsellProduct) {
      showMessage('Product data not available', true);
      return;
    }
    
    if (!upsellProduct.inStock) {
      showMessage(`${upsellProduct.title} is out of stock!`, true);
      return;
    }
    
    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';
    
    try {
      await addToCart(
        variantId,
        upsellProduct.title,
        upsellProduct.image,
        upsellProduct.handle,
        1
      );
      
      showMessage(`${upsellProduct.title} added to cart!`);
    } catch (error) {
      showMessage(error.message || 'Error adding to cart', true);
    }
    
    btn.disabled = false;
    btn.textContent = originalText;
  }
  
  // ==========================================
  // SHOPIFY PRICE SYNC
  // ==========================================
  async function syncMainProductData() {
    if (isSyncing) return;
    isSyncing = true;
    
    try {
      const response = await fetch(`/products/${mainProductHandle}.js`);
      if (!response.ok) throw new Error(`Failed to load product: ${mainProductHandle}`);
      
      const product = await response.json();
      const variant = product.variants.find(v => String(v.id) === String(currentVariantId));
      
      if (variant) {
        currentPrice = variant.price / 100;
        isInStock = variant.available === true;
        
        if (mainPriceEl) mainPriceEl.textContent = formatMoney(currentPrice);
        
        updateAddToCartButton();
        updateWhatsAppLink();
        
        console.log(`White Musk Body Oil synced: $${currentPrice} (In stock: ${isInStock})`);
      } else {
        console.warn(`Variant ${currentVariantId} not found. Using fallback price $${fallbackPrice}`);
        if (mainPriceEl) mainPriceEl.textContent = formatMoney(fallbackPrice);
      }
    } catch (error) {
      console.error('Failed to sync main product data:', error);
      if (mainPriceEl) mainPriceEl.textContent = formatMoney(fallbackPrice);
    } finally {
      isSyncing = false;
    }
  }
  
  async function syncUpsellProduct(upsellConfig) {
    try {
      const response = await fetch(`/products/${upsellConfig.handle}.js`);
      if (!response.ok) throw new Error(`Failed to load upsell: ${upsellConfig.handle}`);
      
      const product = await response.json();
      const variant = product.variants.find(v => String(v.id) === String(upsellConfig.variantId));
      
      if (variant) {
        const price = variant.price / 100;
        const inStock = variant.available === true;
        
        upsellData[upsellConfig.variantId] = {
          title: product.title || upsellConfig.title,
          price: price,
          inStock: inStock,
          image: product.featured_image || upsellConfig.image,
          handle: upsellConfig.handle
        };
        
        const priceElement = document.getElementById(upsellConfig.priceElementId);
        if (priceElement) priceElement.textContent = formatMoney(price);
        
        const card = document.querySelector(`.sapuna-upsell-card[data-upsell-variant-id="${upsellConfig.variantId}"]`);
        const addBtn = card ? card.querySelector('.sapuna-upsell-add-btn') : null;
        
        if (addBtn) {
          if (!inStock) {
            addBtn.disabled = true;
            addBtn.textContent = 'Sold Out';
          } else {
            addBtn.disabled = false;
            addBtn.textContent = 'Add to Cart';
          }
        }
      } else {
        const priceElement = document.getElementById(upsellConfig.priceElementId);
        if (priceElement) priceElement.textContent = formatMoney(upsellConfig.fallbackPrice);
      }
    } catch (error) {
      console.error(`Failed to sync upsell product ${upsellConfig.handle}:`, error);
      const priceElement = document.getElementById(upsellConfig.priceElementId);
      if (priceElement) priceElement.textContent = formatMoney(upsellConfig.fallbackPrice);
    }
  }
  
  async function syncAllUpsellProducts() {
    for (const config of upsellConfigs) {
      await syncUpsellProduct(config);
    }
  }
  
  // ==========================================
  // CARD CLICK REDIRECT
  // ==========================================
  function initCardRedirects() {
    document.querySelectorAll('.sapuna-upsell-card').forEach(card => {
      const productUrl = card.getAttribute('data-upsell-handle');
      if (productUrl) {
        card.style.cursor = 'pointer';
        card.addEventListener('click', function(e) {
          if (e.target.closest('.sapuna-upsell-add-btn')) {
            return;
          }
          window.location.href = productUrl;
        });
      }
    });
  }
  
  // ==========================================
  // EVENT LISTENERS
  // ==========================================
  if (minusBtn) {
    minusBtn.addEventListener('click', function() {
      if (quantity > 1) {
        quantity--;
        if (quantitySpan) quantitySpan.textContent = quantity;
      }
    });
  }
  
  if (plusBtn) {
    plusBtn.addEventListener('click', function() {
      quantity++;
      if (quantitySpan) quantitySpan.textContent = quantity;
    });
  }
  
  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', handleMainAddToCart);
  }
  
  document.querySelectorAll('.sapuna-upsell-add-btn').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      const variantId = parseInt(btn.getAttribute('data-variant-id'));
      handleUpsellAddToCart(e, btn, variantId);
    });
  });
  
  const reviewLink = document.querySelector('.sapuna-review-count');
  if (reviewLink) {
    reviewLink.addEventListener('click', function() {
      const reviewsSection = document.getElementById('shopify-product-reviews') || document.querySelector('[data-reviews]');
      if (reviewsSection) reviewsSection.scrollIntoView({ behavior: 'smooth' });
    });
  }
  
  // Collapsibles
  document.querySelectorAll('.sapuna-collapsible').forEach(function(coll) {
    const header = coll.querySelector('.sapuna-collapsible-header');
    const content = coll.querySelector('.sapuna-collapsible-content');
    const icon = header ? header.querySelector('.sapuna-collapsible-icon') : null;
    
    if (header && content) {
      header.addEventListener('click', function() {
        const isOpen = content.classList.contains('open');
        content.classList.toggle('open', !isOpen);
        if (icon) {
          icon.textContent = isOpen ? '+' : '−';
        }
      });
    }
  });
  
  // ==========================================
  // INITIALIZATION
  // ==========================================
  syncMainProductData();
  syncAllUpsellProducts();
  initCardRedirects();
  
  setInterval(syncMainProductData, 300000);
  setInterval(syncAllUpsellProducts, 300000);
  
  console.log('Sapuna White Musk Body Oil - Initialized');
})();